import type { RouteRecordRaw } from 'vue-router'

import { PAGE_TITLE } from './copy'

export const routes: RouteRecordRaw[] = [
  {
    path: '/guardrails',
    name: 'guardrails',
    component: () => import('./GuardrailsView.vue'),
    meta: { title: PAGE_TITLE, engineScoped: true },
  },
]
